// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Fs9efCsCsvtOilia1Vi6:hover{text-decoration:underline}", "",{"version":3,"sources":["webpack://./src/templates/lessonOverview/lesson-standards.module.scss"],"names":[],"mappings":"AAAA,4BACE,yBAAA","sourcesContent":[".categoryShortcode:hover {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"categoryShortcode": "Fs9efCsCsvtOilia1Vi6"
};
export default ___CSS_LOADER_EXPORT___;
